const session = {
	set: (key, val) => window.localStorage.setItem(key, JSON.stringify(val)),
	get: key => JSON.parse(window.localStorage.getItem(key)),
	unset: key => window.localStorage.removeItem(key),
	getURLParam: val => new URLSearchParams(window.location.search).get(val)
};

export default session;
